var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { ToolbarWithOnClick } from '../../common/Toolbar';
import { useParams } from 'react-router';
import Loading from '../../common/Loading';
import { Body } from '../../root/PageRouter';
import { Grid } from '../../common/Tile';
import { SafeTermTile } from './safe-term-tile';
import { getDisplayName } from '../../../utils/utils';
import { useRouter } from '../../../context/router-context';
import CenteredSign from '../../common/CenteredSign';
import { A } from '../../common/Links';
import { refetchSafesPageQuery, useCreateSafeCertificateMutation, useDeleteSafeTermMutation, useSafesPageQuery, } from '../../../__generated__/graphql';
import CreateSafeTermModal from '../safe-terms/CreateSafeTermModal';
function Toolbar(props) {
    return _jsx(ToolbarWithOnClick, __assign({ onClick: props.onClick }, { children: "SAFEs" }), void 0);
}
export function SafesPage() {
    var _a;
    // Router
    var goForwardClick = useRouter().goForwardClick;
    var organizationId = useParams().organizationId;
    // State
    var _b = React.useState(false), createSafeTermModalIsOpen = _b[0], setCreateSafeTermModalIsOpen = _b[1];
    // Helpers
    var openCreateSafeTermModal = function () {
        setCreateSafeTermModalIsOpen(true);
    };
    var closeCreateSafeTermModal = function () {
        setCreateSafeTermModalIsOpen(false);
    };
    // GraphQL query
    var _c = useSafesPageQuery({
        variables: { organizationId: organizationId },
    }), loading = _c.loading, data = _c.data;
    var safeTerms = ((_a = data === null || data === void 0 ? void 0 : data.organization) === null || _a === void 0 ? void 0 : _a.safeTerms) || [];
    // GraphQL mutation - delete SAFE term
    var deleteSafeTerm = useDeleteSafeTermMutation({
        refetchQueries: [refetchSafesPageQuery({ organizationId: organizationId })],
    })[0];
    // GraphQL mutation - create SAFE certificate
    var createSafeCertificate = useCreateSafeCertificateMutation({
        refetchQueries: [refetchSafesPageQuery({ organizationId: organizationId })],
    })[0];
    // Event handlers
    function handleOnDeleteClick(safeTermId) {
        return function () { return deleteSafeTerm({ variables: { input: { safeTermId: safeTermId } } }); };
    }
    function handleOnEditClick(id) {
        return goForwardClick("safe-terms/" + id + "/update", { replaceLast: true });
    }
    function handleSafeCertificateClick(id) {
        return goForwardClick("safes/" + id, { replaceLast: true });
    }
    function handleCreateSafeCertificate(safeTermId) {
        var _this = this;
        return function (safeCertificateData) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, createSafeCertificate({
                            variables: {
                                input: {
                                    safeTermId: safeTermId,
                                    principal: safeCertificateData.principal,
                                    holderName: safeCertificateData.holderName,
                                    holderEmail: safeCertificateData.holderEmail,
                                    issuedAt: safeCertificateData.issuedAt,
                                    remarks: safeCertificateData.remarks,
                                },
                            },
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
    }
    if (loading) {
        return _jsx(Loading, {}, void 0);
    }
    if (safeTerms.length === 0) {
        return (_jsxs(_Fragment, { children: [_jsx(CreateSafeTermModal, { open: createSafeTermModalIsOpen, onCancel: closeCreateSafeTermModal }, void 0),
                _jsx(Toolbar, { onClick: openCreateSafeTermModal }, void 0),
                _jsx(CenteredSign, { children: _jsx(A, __assign({ onClick: openCreateSafeTermModal }, { children: "Create a SAFE term" }), void 0) }, void 0)] }, void 0));
    }
    return (_jsxs(_Fragment, { children: [_jsx(CreateSafeTermModal, { open: createSafeTermModalIsOpen, onCancel: closeCreateSafeTermModal }, void 0),
            _jsx(Toolbar, { onClick: openCreateSafeTermModal }, void 0),
            _jsx(Body, { children: _jsx(Grid, { children: safeTerms.map(function (safeTerm) { return (_jsx(SafeTermTile, { name: safeTerm.name, discount: safeTerm.discount, valuationBasis: safeTerm.valuationBasis, valuationCap: safeTerm.valuationCap, safeCertificates: safeTerm.safes.map(function (safeCertificate) { return ({
                            id: safeCertificate.id,
                            state: safeCertificate.state,
                            principal: safeCertificate.principal,
                            holder: getDisplayName(safeCertificate),
                            onClick: handleSafeCertificateClick(safeCertificate.id),
                        }); }), onDeleteConfirm: handleOnDeleteClick(safeTerm.id), onEditClick: handleOnEditClick(safeTerm.id), onAddClick: handleCreateSafeCertificate(safeTerm.id) }, safeTerm.id)); }) }, void 0) }, void 0)] }, void 0));
}
//# sourceMappingURL=safes-page.js.map